<template>
    <div class="page-background" v-if="background !== null">
        <img :src="background" />
    </div>
</template>

<style lang="scss" scoped>
    .page-background {
        background-color: #242424;

        img {
            float: left;
            opacity: 0.4;
            min-width: 100%;
            min-height: 100%;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                background: null
            }
        },

        mounted() {
            eventHub.$on('background.set', this.set)
        },

        destroyed() {
            eventHub.$off('background.set', this.set)
        },

        methods: {
            set(src) {
                this.background = src
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PageBackground.vue?20538796